"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fn_bindings_matcher = exports.fn_binding_matcher = void 0;
const pt = __importStar(require("@cicada-lang/partech"));
const matchers = __importStar(require("."));
const Exps = __importStar(require("../../exp"));
function fn_binding_matcher(tree) {
    return pt.matcher({
        "fn_binding:name": ({ name }, { span }) => Exps.FnBindingName(pt.str(name), span),
        "fn_binding:annotated": ({ name, t }, { span }) => Exps.FnBindingAnnotated(pt.str(name), matchers.exp_matcher(t), span),
        "fn_binding:implicit": ({ name }, { span }) => Exps.FnBindingImplicit(pt.str(name), span),
        "fn_binding:annotated_implicit": ({ name, t }, { span }) => Exps.FnBindingAnnotatedImplicit(pt.str(name), matchers.exp_matcher(t), span),
    })(tree);
}
exports.fn_binding_matcher = fn_binding_matcher;
function fn_bindings_matcher(tree) {
    return pt.matcher({
        "fn_bindings:fn_bindings": ({ entries, last_entry }) => [
            ...pt.matchers.zero_or_more_matcher(entries).map(fn_binding_matcher),
            fn_binding_matcher(last_entry),
        ],
        "fn_bindings:fn_bindings_bracket_separated": ({ entries, last_entry }) => [
            ...pt.matchers.zero_or_more_matcher(entries).map(fn_binding_matcher),
            fn_binding_matcher(last_entry),
        ],
    })(tree);
}
exports.fn_bindings_matcher = fn_bindings_matcher;
//# sourceMappingURL=fn_binding_matcher.js.map